import styled from "styled-components"

export const Container = styled.section`
    width: 90%;
    min-height: calc(100vh - (110px + 2rem));
    overflow: auto;

    padding: 1rem 5%;

    display: flex;
    align-items: center;
    justify-content: center;

`
